// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer defaults {
  :root {
    --readthedocs-notification-font-size: calc(
      var(--readthedocs-font-size) * 0.85
    );
    --readthedocs-notification-font-family: var(--readthedocs-font-family);

    --readthedocs-notification-color: rgb(64, 64, 64);
    --readthedocs-notification-background-color: rgb(234, 234, 234);
    --readthedocs-notification-title-color: rgba(96, 96, 96);
    --readthedocs-notification-title-background-color: rgb(224, 224, 224);
    --readthedocs-notification-link-color: rgb(8, 140, 219);

    /* TODO these should be replaced with a better pattern for splitting up
     * light and dark mode colors. Do not reuse this pattern. */
    --readthedocs-notification-inverted-color: rgb(234, 234, 234);
    --readthedocs-notification-inverted-background-color: rgb(64, 64, 64);
    --readthedocs-notification-inverted-title-color: rgba(255, 255, 255, 0.9);
    --readthedocs-notification-title-background-color: rgb(48, 48, 48);
    --readthedocs-notification-inverted-link-color: rgb(134, 203, 243);
  }
}

:host > div {
  margin: 1rem 0rem;
  padding-top: var(--readthedocs-notification-font-size);
  padding-bottom: var(--readthedocs-notification-font-size);
  overflow: auto;
  border-radius: 0.5rem;
  font-family: var(--readthedocs-notification-font-family);
  font-size: var(--readthedocs-notification-font-size);
  color: var(--readthedocs-notification-color);
  background-color: var(--readthedocs-notification-background-color);
}

:host(.floating) > div {
  position: fixed;
  top: 2rem;
  left: 20%; /* (100 - width) / 2 */
  width: 60%;
  z-index: 1750;
}

:host(.toast) > div {
  position: fixed;
  padding-top: 0.75em;
  padding-bottom: 0.75em;
  margin: 0.75rem 0rem;
  top: 2rem;
  right: 2rem;
  z-index: 1750;
  width: 35rem;
  max-width: calc(100vw - 4rem);
}

@media (max-width: 640px) {
  :host(.toast) > div {
    right: 0.5rem;
  }

  :host(.floating) > div {
    width: 95%;
    left: 2%;
  }
}

:host(.raised) > div {
  box-shadow:
    0 2px 4px 0 rgba(34, 36, 38, 0.12),
    0 2px 10px 0 rgba(34, 36, 38, 0.15);
}

:host(.titled) > div {
  padding: 0rem;
  text-align: center;
}

:host > div > svg.header.icon {
  height: 2em;
  padding: 0.5rem 1.5rem;
  float: left;
}

:host(.toast) > div > svg.header.icon {
  height: 1.5em;
}

:host(.titled) > div > svg.header.icon {
  display: none;
}

:host(.inverted) > div {
  color: var(--readthedocs-notification-inverted-color);
  background-color: var(--readthedocs-notification-inverted-background-color);
}

:host > div a {
  color: var(--readthedocs-notification-link-color);
  text-decoration: none;
}

:host(.inverted) > div a {
  color: var(--readthedocs-notification-inverted-link-color);
}

:host > div > .title {
  padding: 0.25rem 1em;
  margin-bottom: 0.25rem;
  line-height: 1em;
  font-weight: bold;
}
:host > div > div.content {
  line-height: 1.2em;
  padding: 0 1.5em;
}

:host(.toast) > div > .title {
  padding: 0rem 1em;
}

:host(.titled) > div > .title {
  display: block;
  margin: 0rem;
  padding: 0.1rem 1em;
  line-height: 2em;
  border-radius: 0.5rem 0.5rem 0 0;
  color: var(--readthedocs-notification-title-color);
  background-color: var(--readthedocs-notification-title-background-color);
  vertical-align: middle;
  font-weight: bold;
}
:host(.titled) > div > div.content {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0rem 0.65rem 0rem 0.65rem;
}

:host(.inverted) > div > .title {
  color: var(--readthedocs-notification-inverted-title-color);
}

:host(.inverted.titled) > div > .title {
  background-color: var(--readthedocs-notification-title-background-color);
}

:host > div > .title > .right {
  float: right;
}

:host > div > .title > .right > svg {
  display: inline-block;
  height: 1em;
  vertical-align: middle;
  cursor: pointer;
  color: var(--readthedocs-notification-title-color);
  font-weight: normal;
}

:host(.inverted) > div > .title > .right > svg {
  color: var(--readthedocs-notification-inverted-title-color);
}
:host(.titled) > div > .title > .right > svg {
  margin: 0.5rem 0rem;
}
`, "",{"version":3,"sources":["webpack://./src/notification.css"],"names":[],"mappings":"AAAA;EACE;IACE;;KAEC;IACD,sEAAsE;;IAEtE,iDAAiD;IACjD,+DAA+D;IAC/D,wDAAwD;IACxD,qEAAqE;IACrE,uDAAuD;;IAEvD;+DAC2D;IAC3D,6DAA6D;IAC7D,qEAAqE;IACrE,yEAAyE;IACzE,kEAAkE;IAClE,kEAAkE;EACpE;AACF;;AAEA;EACE,iBAAiB;EACjB,sDAAsD;EACtD,yDAAyD;EACzD,cAAc;EACd,qBAAqB;EACrB,wDAAwD;EACxD,oDAAoD;EACpD,4CAA4C;EAC5C,kEAAkE;AACpE;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS,EAAE,sBAAsB;EACjC,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE;;uCAEqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,2EAA2E;AAC7E;;AAEA;EACE,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kDAAkD;EAClD,wEAAwE;EACxE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;AAC7D;AACA;EACE,mBAAmB;AACrB","sourcesContent":["@layer defaults {\n  :root {\n    --readthedocs-notification-font-size: calc(\n      var(--readthedocs-font-size) * 0.85\n    );\n    --readthedocs-notification-font-family: var(--readthedocs-font-family);\n\n    --readthedocs-notification-color: rgb(64, 64, 64);\n    --readthedocs-notification-background-color: rgb(234, 234, 234);\n    --readthedocs-notification-title-color: rgba(96, 96, 96);\n    --readthedocs-notification-title-background-color: rgb(224, 224, 224);\n    --readthedocs-notification-link-color: rgb(8, 140, 219);\n\n    /* TODO these should be replaced with a better pattern for splitting up\n     * light and dark mode colors. Do not reuse this pattern. */\n    --readthedocs-notification-inverted-color: rgb(234, 234, 234);\n    --readthedocs-notification-inverted-background-color: rgb(64, 64, 64);\n    --readthedocs-notification-inverted-title-color: rgba(255, 255, 255, 0.9);\n    --readthedocs-notification-title-background-color: rgb(48, 48, 48);\n    --readthedocs-notification-inverted-link-color: rgb(134, 203, 243);\n  }\n}\n\n:host > div {\n  margin: 1rem 0rem;\n  padding-top: var(--readthedocs-notification-font-size);\n  padding-bottom: var(--readthedocs-notification-font-size);\n  overflow: auto;\n  border-radius: 0.5rem;\n  font-family: var(--readthedocs-notification-font-family);\n  font-size: var(--readthedocs-notification-font-size);\n  color: var(--readthedocs-notification-color);\n  background-color: var(--readthedocs-notification-background-color);\n}\n\n:host(.floating) > div {\n  position: fixed;\n  top: 2rem;\n  left: 20%; /* (100 - width) / 2 */\n  width: 60%;\n  z-index: 1750;\n}\n\n:host(.toast) > div {\n  position: fixed;\n  padding-top: 0.75em;\n  padding-bottom: 0.75em;\n  margin: 0.75rem 0rem;\n  top: 2rem;\n  right: 2rem;\n  z-index: 1750;\n  width: 35rem;\n  max-width: calc(100vw - 4rem);\n}\n\n@media (max-width: 640px) {\n  :host(.toast) > div {\n    right: 0.5rem;\n  }\n\n  :host(.floating) > div {\n    width: 95%;\n    left: 2%;\n  }\n}\n\n:host(.raised) > div {\n  box-shadow:\n    0 2px 4px 0 rgba(34, 36, 38, 0.12),\n    0 2px 10px 0 rgba(34, 36, 38, 0.15);\n}\n\n:host(.titled) > div {\n  padding: 0rem;\n  text-align: center;\n}\n\n:host > div > svg.header.icon {\n  height: 2em;\n  padding: 0.5rem 1.5rem;\n  float: left;\n}\n\n:host(.toast) > div > svg.header.icon {\n  height: 1.5em;\n}\n\n:host(.titled) > div > svg.header.icon {\n  display: none;\n}\n\n:host(.inverted) > div {\n  color: var(--readthedocs-notification-inverted-color);\n  background-color: var(--readthedocs-notification-inverted-background-color);\n}\n\n:host > div a {\n  color: var(--readthedocs-notification-link-color);\n  text-decoration: none;\n}\n\n:host(.inverted) > div a {\n  color: var(--readthedocs-notification-inverted-link-color);\n}\n\n:host > div > .title {\n  padding: 0.25rem 1em;\n  margin-bottom: 0.25rem;\n  line-height: 1em;\n  font-weight: bold;\n}\n:host > div > div.content {\n  line-height: 1.2em;\n  padding: 0 1.5em;\n}\n\n:host(.toast) > div > .title {\n  padding: 0rem 1em;\n}\n\n:host(.titled) > div > .title {\n  display: block;\n  margin: 0rem;\n  padding: 0.1rem 1em;\n  line-height: 2em;\n  border-radius: 0.5rem 0.5rem 0 0;\n  color: var(--readthedocs-notification-title-color);\n  background-color: var(--readthedocs-notification-title-background-color);\n  vertical-align: middle;\n  font-weight: bold;\n}\n:host(.titled) > div > div.content {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding: 0rem 0.65rem 0rem 0.65rem;\n}\n\n:host(.inverted) > div > .title {\n  color: var(--readthedocs-notification-inverted-title-color);\n}\n\n:host(.inverted.titled) > div > .title {\n  background-color: var(--readthedocs-notification-title-background-color);\n}\n\n:host > div > .title > .right {\n  float: right;\n}\n\n:host > div > .title > .right > svg {\n  display: inline-block;\n  height: 1em;\n  vertical-align: middle;\n  cursor: pointer;\n  color: var(--readthedocs-notification-title-color);\n  font-weight: normal;\n}\n\n:host(.inverted) > div > .title > .right > svg {\n  color: var(--readthedocs-notification-inverted-title-color);\n}\n:host(.titled) > div > .title > .right > svg {\n  margin: 0.5rem 0rem;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
